
































import { Component, Provide, Vue } from "vue-property-decorator";
import { gallerys } from "@/config/host.config";
import axios from "@/api/AuthAPI/auth-request-api";

import { AxiosRequestConfig, AxiosResponse, AxiosError } from "axios";
import {
  IPhotoFormat,
  IGalleryFTP,
  ICategory,
  IGallery,
} from "@/@types/gallsery/gallery";
@Component({})
export default class GalleryPage extends Vue {
  @Provide("foldersbg") foldersbg = "foldersbg";
  @Provide("folder") folder = "gallery";

  categorys: Array<ICategory> = [];
  gallerys: Array<IGallery> = [];
  formats: Array<IPhotoFormat> = [];
  activeCategory = "";
  activeGallery = "";

  show = false;

  deleteGalleryElement(id: string): void {
    if (!this.activeGallery) return;
    for (const gallery of this.gallerys) {
      if (gallery._id == this.activeGallery) {
        const inx = gallery.photos.indexOf(id);
        if (inx != -1) gallery.photos.splice(inx, 1);
        return;
      }
    }
  }

  dropGallery(id: string = this.activeGallery): void {
    for (let i = 0; i < this.gallerys.length; i++) {
      if (this.gallerys[i]._id == id) {
        this.gallerys.splice(i, 1);
        this.activeGallery = "";
        return;
      }
    }
  }

  dropFolder(id: string): void {
    for (let i = 0; i < this.categorys.length; i++) {
      if (this.categorys[i]._id == id) {
        this.categorys.splice(i, 1);
        return;
      }
    }
  }

  back(): void {
    const categoryPath = this.activeCategory.split("/");
    if (!categoryPath[categoryPath.length - 1]) categoryPath.pop();
    if (categoryPath.length == 1) this.activeCategory = "";
    else {
      categoryPath.pop();
      this.activeCategory = categoryPath.join("/");
    }
    this.createStartList();
  }

  createFormat(f: IPhotoFormat): void {
    for (let i = 0; i < this.formats.length; i++) {
      if (this.formats[i]._id === f._id) {
        Vue.set(this.formats, i, f);
        return;
      }
    }
    this.formats.push(f);
  }

  deleteFormat(id: string): void {
    for (let i = 0; i < this.formats.length; i++) {
      if (this.formats[i]._id == id) {
        this.formats.splice(i, 1);
        return;
      }
    }
    this.createGalleryFormatList();
  }

  async getGalleryFTP(
    uri: string,
    config: AxiosRequestConfig
  ): Promise<IGalleryFTP> {
    return new Promise<IGalleryFTP>((res, rej) => {
      axios
        .get(uri, config)
        .then((response: AxiosResponse) => {
          if (response.status === 200) res(response.data);
        })
        .catch((error: AxiosError) => {
          rej(error);
        });
    });
  }

  async updateFolder(data: ICategory): Promise<void> {
    if (!data) return;
    const method = data._id ? "put" : "post";
    const url = data._id
      ? `${gallerys.categotys}/${data._id}`
      : gallerys.categotys;
    const params = data._id ? {} : { path: this.activeCategory };

    try {
      const res: AxiosResponse<ICategory> = await axios({
        method,
        url,
        data,
        params,
      });
      if (res.status === 200) {
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("error.200")),
        });
      }
      if (data._id)
        for (let i = 0; i < this.categorys.length; i++) {
          if (data._id == this.categorys[i]._id) {
            Vue.set(this.categorys, i, data);
            return;
          }
        }
      this.categorys.push(res.data);
    } catch (error) {
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("alerts.emptyUpdate")),
        type: "warn",
      });
    }
  }

  async updateGallery(data: IGallery): Promise<void> {
    if (!data) return;
    const method = data._id ? "put" : "post";
    const url = data._id ? `${gallerys.mainAPI}/${data._id}` : gallerys.mainAPI;
    const params = data._id ? {} : { path: this.activeCategory };
    try {
      const res = await axios({ method, url, data, params });
      if (res.status === 200) {
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("error.200")),
        });
        if (data._id) {
          for (let i = 0; i < this.gallerys.length; i++) {
            if (data._id == this.gallerys[i]._id) {
              Vue.set(this.gallerys, i, data);
              return;
            }
          }
        }
        this.gallerys.push(res.data);
      }
    } catch (error) {
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("alerts.emptyUpdate")),
        type: "warn",
      });
    }
  }

  async getPhotoPhormats(
    uri: string,
    config: AxiosRequestConfig
  ): Promise<Array<IPhotoFormat>> {
    return new Promise<Array<IPhotoFormat>>((res, rej) => {
      axios
        .get(uri, config)
        .then((response: AxiosResponse) => {
          if (response.status === 200) res(response.data);
        })
        .catch((error: AxiosError) => {
          rej(error);
        });
    });
  }

  createStartList(): void {
    this.categorys = [];
    this.gallerys = [];
    const uri = gallerys.ftp;
    const config = {
      params: { path: this.activeCategory, "match[deleted][value]": false },
    };
    this.getGalleryFTP(uri, config)
      .then((ftp: IGalleryFTP) => {
        this.categorys = ftp.categorys;
        this.gallerys = ftp.gallerys;
        this.show = true;
      })
      .catch((e: AxiosError) => {
        console.log(e);
        this.show = false;
      });
  }

  createGalleryFormatList(): void {
    const uri = gallerys.formats;
    const config: AxiosRequestConfig = {
      params: { "match[deleted][value]": false },
    };
    this.getPhotoPhormats(uri, config)
      .then((formats: Array<IPhotoFormat>) => {
        this.formats = formats;
      })
      .catch((e: AxiosError) => {
        console.log(e);
      });
  }

  start(): void {
    this.activeCategory = "";
    this.activeGallery = "";
    this.createStartList();
    this.createGalleryFormatList();
  }

  mounted(): void {
    this.start();
  }
}
